export default __webpack_public_path__ + "static/media/detail_big_16_5.89d134e4.jpg";